"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;

/**
 * Master list of valid schemas for analytics actions
 *
 * Each event describes one ActionType
 */

/**
 * The top-level actions an Event describes.
 *
 * Each ActionType corresponds with a table in Redshift.
 */
let ActionType;
exports.ActionType = ActionType;

(function (ActionType) {
  ActionType["authImpression"] = "authImpression";
  ActionType["clickedArtistGroup"] = "clickedArtistGroup";
  ActionType["clickedArtistSeriesGroup"] = "clickedArtistSeriesGroup";
  ActionType["clickedArtworkGroup"] = "clickedArtworkGroup";
  ActionType["clickedAuctionGroup"] = "clickedAuctionGroup";
  ActionType["clickedCollectionGroup"] = "clickedCollectionGroup";
  ActionType["clickedFairGroup"] = "clickedFairGroup";
  ActionType["clickedMainArtworkGrid"] = "clickedMainArtworkGrid";
  ActionType["createdAccount"] = "createdAccount";
  ActionType["focusedOnConversationMessageInput"] = "focusedOnConversationMessageInput";
  ActionType["followedArtist"] = "followedArtist";
  ActionType["resetYourPassword"] = "resetYourPassword";
  ActionType["successfullyLoggedIn"] = "successfullyLoggedIn";
  ActionType["sentConversationMessage"] = "sentConversationMessage";
  ActionType["tappedArtistGroup"] = "tappedArtistGroup";
  ActionType["tappedArtistSeriesGroup"] = "tappedArtistSeriesGroup";
  ActionType["tappedArtworkGroup"] = "tappedArtworkGroup";
  ActionType["tappedAuctionGroup"] = "tappedAuctionGroup";
  ActionType["tappedCollectionGroup"] = "tappedCollectionGroup";
  ActionType["tappedExploreGroup"] = "tappedExploreGroup";
  ActionType["tappedFairGroup"] = "tappedFairGroup";
  ActionType["tappedConsign"] = "tappedConsign";
  ActionType["tappedMainArtworkGrid"] = "tappedMainArtworkGrid";
  ActionType["tappedPromoSpace"] = "tappedPromoSpace";
  ActionType["tappedTabBar"] = "tappedTabBar";
  ActionType["tappedViewingRoomGroup"] = "tappedViewingRoomGroup";
  ActionType["timeOnPage"] = "timeOnPage";
  ActionType["unfollowedArtist"] = "unfollowedArtist";
})(ActionType || (exports.ActionType = ActionType = {}));